export default __webpack_public_path__ + "static/media/bg-recommendation.d08d7610.webp";